import { h, Host } from "@stencil/core";
export class ModalFooter {
    render() {
        return (h(Host, { key: '63fcdaf6d3ba3124cfb1ffb82a26d315f233d6ac', class: "ux-modal-footer" }, h("slot", { key: '2e4571e84f12a8fefcccef2d5327a749aa10c90a' })));
    }
    static get is() { return "ux-modal-footer"; }
    static get originalStyleUrls() {
        return {
            "$": ["modal-footer.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["modal-footer.css"]
        };
    }
}
//# sourceMappingURL=modal-footer.js.map
